import { api } from "..";

const endpoint = "/api/accounting";

// ECONOMIC ACTIVITIES
export const getEconomicActivityList = () => {
  return api.get(`${endpoint}/economic-activities/`);
};

export const addEconomicActivity = (data) => {
  return api.post(`${endpoint}/economic-activities/`, data);
};

export const updateEconomicActivity = (id, data) => {
  return api.put(`${endpoint}/economic-activities/${id}`, data);
};

export const deleteEconomicActivity = (id) => {
  return api.delete(`${endpoint}/economic-activities/${id}`);
};

// EXPENSE ACCOUNTS
export const getExpenseAccountList = (qp) => {
  // const queryParams = new URLSearchParams();

  // console.log(qp);  
  // if (qp) {
  //   let { name, ExpenseAccountIds, pageNumber, pageSize, companyId, contpaqiCode } = qp;
  //   if (name) queryParams.append("name", name);

  //   // Manually add each ExpenseAccountId without the brackets
  //   if (ExpenseAccountIds && ExpenseAccountIds.length > 0) {
  //     ExpenseAccountIds.forEach((id) =>
  //       queryParams.append("ExpenseAccountIds", id)
  //     );
  //   }

  //   if (pageNumber) queryParams.append("pageNumber", pageNumber);
  //   if (pageSize) queryParams.append("pageSize", pageSize);
  //   if (companyId) queryParams.append("companyId", companyId);
  //   if (contpaqiCode) queryParams.append("contpaqiCode", contpaqiCode);
  // }

  return api.get(`${endpoint}/expense-accounts/`, { params: qp });
};

export const addExpenseAccount = (data) => {
  return api.post(`${endpoint}/expense-accounts/`, data);
};

export const updateExpenseAccount = (id, data) => {
  return api.put(`${endpoint}/expense-accounts/${id}`, data);
};

export const deleteExpenseAccount = (id) => {
  return api.delete(`${endpoint}/expense-accounts/${id}`);
};

// TAX RETENTIONS
export const getTaxRetentionList = (qp) => {
  return api.get(`${endpoint}/tax-retentions/`, { params: qp });
};

export const getTaxRetentionById = (id) => {
  return api.get(`${endpoint}/tax-retentions/${id}`);
};

export const addTaxRetention = (data) => {
  return api.post(`${endpoint}/tax-retentions/`, data);
};

export const updateTaxRetention = (id, data) => {
  return api.put(`${endpoint}/tax-retentions/${id}`, data);
};

export const deleteTaxRetention = (id) => {
  return api.delete(`${endpoint}/tax-retentions/${id}`);
};
